import React, { useContext } from "react";
import { HedAndDek } from "@bloomberg/media-ui-article";

import { GridTopContent } from "~components/GridLayout";
import BasicByline from "~components/Lede/BasicByline";
import SectionIdentifier from "~components/SectionIdentifier";
import { CurrentStoryContext } from "~utils/currentStoryContext";
import { getShouldShowAITakeaways } from "~utils/getShouldShowAITakeaways";
import isOpinion from "~utils/isOpinion";

import styles from "./basicHeader.module.css";

export default function BasicHeader(): JSX.Element {
    const { story } = useContext(CurrentStoryContext);
    const isOpinionArticle = isOpinion(story);
    const { byline } = story;
    const shouldShowAbstract = !getShouldShowAITakeaways(story);

    return (
        <>
            <SectionIdentifier
                className={styles.sectionIdentifier}
                story={story}
            />
            <GridTopContent>
                <HedAndDek
                    headline={story.headline}
                    abstract={shouldShowAbstract ? story.abstract : undefined}
                    className={styles.headAndDek}
                    dek={story.summaryHtml}
                />
                {/* Basic Article Byline and TTS are rendered in BasicContent component */}
                {isOpinionArticle && byline && (
                    <BasicByline story={story} className={styles.bylineBio} />
                )}
            </GridTopContent>
        </>
    );
}
